import styled from "styled-components";
export const IconWrapper = styled.span.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-18tdawi-0"
})(["display:grid;& > *{margin:auto;}", " flex-shrink:0;", ""], props => props.marginRight && "margin-right: 8px;", props => props.wide && "margin: auto 16px;");
export default IconWrapper;